/**
 * Timestamp strategy (Phase 1, target-architecture.md):
 *
 *  - Storage is always UTC ISO-8601 text (`2026-08-31T12:34:56.789Z`).
 *  - Business-time decisions (fiscal year, invoice date rendering) are made in
 *    the PROPERTY's timezone, which is replicated onto the device - never the
 *    device's own locale, which fixes the server's unpinned-TZ blur for the
 *    device series (ADR-011).
 *  - Server time is a different clock: the sync layer records skew, and no
 *    local column ever pretends to hold server time.
 */
export const nowIso = () => new Date().toISOString();
/**
 * The Indian financial year label ("2026-27") for an instant, evaluated in
 * the given IANA timezone. 1 April to 31 March, matching the server's
 * `fiscalYear()` in apps/api/src/services/sequence.ts - except pinned to the
 * property timezone instead of the host locale.
 */
export function fiscalYear(timezone, at = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: timezone,
        year: 'numeric',
        month: 'numeric',
    }).formatToParts(at);
    const year = Number(parts.find((p) => p.type === 'year')?.value);
    const month = Number(parts.find((p) => p.type === 'month')?.value);
    if (!Number.isFinite(year) || !Number.isFinite(month)) {
        throw new Error(`Could not resolve fiscal year in timezone ${timezone}`);
    }
    const start = month >= 4 ? year : year - 1;
    return `${start}-${String((start + 1) % 100).padStart(2, '0')}`;
}
/** "2026-27" -> the four-digit stamp used in document numbers ("2627"). */
export function fiscalYearStamp(label) {
    return `${label.slice(2, 4)}${label.slice(5, 7)}`;
}
//# sourceMappingURL=time.js.map